import http from '../util/request'

const API = {
  getScience(projectName) {
    return http.get('/api/web/science/project', { projectName })
  },
  getTimeline() {
    return http.get('/api/web/timeline/list')
  },
  getNewsList(params) {
    return http.get('/api/web/news', params)
  },
  getNewsById(id) {
    return http.get(`/api/web/news/${id}`)
  },
  getNoticeList(params) {
    return http.get('/api/web/notices', params)
  }
}

export default API



// WEBPACK FOOTER //
// ./src/api/api.js